import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const ATLASSIAN_ACCOUNT_FRAGMENT = gqlTagGira`
  fragment AtlassianAccountFragment on AtlassianAccountUser {
    accountId
    accountStatus
    picture
    name
  }
`;

export const USER_FRAGMENT = gqlTagGira`
    fragment jiraSingleUserFieldFragment on JiraSingleSelectUserPickerField {
        user {
            ...AtlassianAccountFragment
        }
        fieldConfig {
            isEditable
        }
    }
`;

export const PEOPLE_FRAGMENT = gqlTagGira`
    fragment jiraPeopleFieldFragment on JiraPeopleField {
        fieldConfig {
          isEditable
        }
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
    }
`;

export const MULTIPLE_USER_FRAGMENT = gqlTagGira`
    fragment jiraMultipleUserFieldFragment on JiraMultipleSelectUserPickerField {
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
        fieldConfig {
          isEditable
        }
    }
`;
